module.exports = __webpack_public_path__ + "fonts/3a2a940c2b258448f584f8555a63d647.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/arrow-alt-left.svg
// module id = 2034
// module chunks = 0